import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject, output } from '@angular/core';
import { SignalsStoreService } from '../signals-store.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { SidebarService } from './sidebar.service';
import { SidebarCheckList } from './sidebar.types';
import { ShopComponent } from '../../shop/shop.component';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCheckboxModule, FormsModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  signalsStore = inject(SignalsStoreService);
  sidebarService = inject(SidebarService);
  #cdr = inject(ChangeDetectorRef);

  hasGlobalMessages = computed(() => !!this.signalsStore.globalMessages().length);

  outIsMenuReady = output<boolean>();

  constructor(public shopComponent: ShopComponent) {
    toObservable(this.sidebarService.sidebar).subscribe((res) => {
      if (!res || res.length === 0) return;
      setTimeout(() => {
        this.outIsMenuReady.emit(true);
      }, 100);
    });
  }

  toggleSidebar() {
    this.signalsStore.isSidebarOpen.update(currentValue => !currentValue);
  }

  handleCheckChange(item: SidebarCheckList, index: number) {
    item.checked = item.sublist != null && item.sublist.every(t => t.checked);
    this.updateSidebarData(item, index);
    this.shopComponent.scrollToTop();
    this.#cdr.markForCheck();
  }

  private updateSidebarData(item: SidebarCheckList, index: number) {
    const sidebar = this.sidebarService.sidebar();
    sidebar[index] = { ...item };
    this.sidebarService.sidebar.update(() => [...sidebar]);
    this.signalsStore.sidebarFilterChanged.set(sidebar);
  }
}
